

{
  document.addEventListener("DOMContentLoaded", () => {
  const marquee = document.querySelector(".LoopMarque");
  if (!marquee || typeof gsap === "undefined") return;

  const originalItems = Array.from(
    marquee.querySelectorAll(".slider__item:not(.marquee-clone)")
  );

  if (!originalItems.length) return;

  let animation = null;
  let resizeTimer = null;

  // Pause / Resume
  marquee.addEventListener("mouseenter", () => {
    if (animation) animation.pause();
  });

  marquee.addEventListener("mouseleave", () => {
    if (animation) animation.resume();
  });

  const setupMarquee = () => {
    // Stop old animation
    if (animation) {
      animation.kill();
      animation = null;
    }

    // Remove old clones
    marquee
      .querySelectorAll(".marquee-clone")
      .forEach((clone) => clone.remove());

    // Reset position
    gsap.set(marquee, {
      x: 0
    });

    // Force layout calculation
    marquee.offsetWidth;

    const firstItem = originalItems[0];
    const lastItem = originalItems[originalItems.length - 1];

    if (!firstItem || !lastItem) return;

    // Get the ACTUAL width of the complete original set.
    // This includes gap/margin between items.
    const firstRect = firstItem.getBoundingClientRect();
    const lastRect = lastItem.getBoundingClientRect();

    const setWidth = lastRect.right - firstRect.left;

    if (!setWidth || setWidth <= 0) return;

    const screenWidth = window.innerWidth;

    // Make sure there are enough copies to cover the screen
    const copiesNeeded = Math.ceil(screenWidth / setWidth) + 3;

    for (let i = 0; i < copiesNeeded; i++) {
      originalItems.forEach((item) => {
        const clone = item.cloneNode(true);

        clone.classList.add("marquee-clone");

        marquee.appendChild(clone);
      });
    }

    // Recalculate after clones are added
    gsap.set(marquee, {
      x: 0
    });

    // Speed: approximately 50px per second
    const duration = setWidth / 50;

    animation = gsap.to(marquee, {
      x: -setWidth,
      duration: duration,
      ease: "none",
      repeat: -1,
      force3D: true
    });
  };

  // Initial setup
  setupMarquee();

  // Optimized resize
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      setupMarquee();
    }, 250);
  });
});
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(".accordion_cus");
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".acco_cus_item");
      if (items.length > 0) {
        items[0].classList.add("open");
      }
      items.forEach((item) => {
        const header = item.querySelector(".acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
  const isLoggedIn = document.body.classList.contains("user-login");
  const wasLoggedIn = localStorage.getItem("was_logged_in") === "true";

  if (isLoggedIn) {
    // User is currently logged in
    localStorage.setItem("was_logged_in", "true");
    return;
  }

  // User was logged in before, but now user-login is gone
  if (!isLoggedIn && wasLoggedIn) {
    // Remove cookies
    document.cookie.split(";").forEach(function (cookie) {
      const cookieName = cookie.split("=")[0].trim();

      document.cookie =
        cookieName +
        "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    });

    // Clear cart
    fetch("/cart/clear.js", {
      method: "POST"
    }).then(function () {
      // Mark logout as handled
      localStorage.removeItem("was_logged_in");

      // Refresh once
      window.location.reload();
    });
  }
});
}